<template lang="pug">
v-container(class="text-center" fluid)
  h1
    v-icon(color="red" size="45") mdi-map-marker-distance
    | Conversor de Coordenadas
  coordinate-manager
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import CoordinateManager from '@/components/geos/CoordinateManager';

export default {
  name: 'CoordinateConversorView',

  components: {
    CoordinateManager
  },

  data: () => ({
  }),

  computed: {
  },

  async mounted() {
    // limpiar los datos del reporte
    this.CHANGE_VALUE({
      value: null,
      varName: 'reportData'
    })
    // traer variables para reporte de los folios
    await this.getFolioVariables();
    // traer las plantillas de reportes de filios
    await this.getFolioReports();
  },

  methods: {
    ...mapActions('reports', ['getFolioVariables', 'getFolioReports']),
    ...mapMutations('reports', ['CHANGE_VALUE']),
  }
};
</script>
      